import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isAndroid, isIOS, isBrowser } from "react-device-detect";
import logo from '../assets/logo-icon.png';
import app_store_logo from '../assets/AppStore.svg';
import google_play_logo from '../assets/google-play.png';
import '../css/SignIn.css';

import { UserActions, ConsultationsActions, NavigationActions } from '../actions';
import { SignIn, Button } from  '../components'

class DynamicLinkScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ios_href: '',
      android_href: '',
    }
  }

  componentDidMount() {
    let props  = this.props || {};
    let match  = props.match || {};
    let params = match.params || {};

    let link_category = params && params.category ? params.category : '';
    let link_data_id  = params && params.id  ? params.id  : '';

    if (isIOS) {
      let deep_url = `teletails://link_category?cat=${link_category}&id=${link_data_id}`;
      window.location = deep_url;
      this.setState({ ...this.state, ios_href: deep_url });
    }

    if (isAndroid) {
      let deep_url = `intent://link_category?cat=${link_category}&id=${link_data_id}#Intent;scheme=teletails;package=com.teletails;end`;
      this.setState({ ...this.state, android_href: deep_url });
    }
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align sign-in-page">
        <div className="flex-container-column" style={{ justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
          <img className="sign-in-logo-image" src={logo} alt="Icon Text" />
          <span style={{ marginTop: 2, fontSize: 24, fontWeight: '600', color: '#404040' }}>TeleTails</span>

          <div style={{ marginTop: 15 }}>
            { this.renderAndroidAnchor(this.state.android_href ? true : false) }
            { this.renderiOSAnchor(this.state.ios_href ? true : false) }
          </div>

          <div className='flex-container-column' style={{ justifyContent: 'center', alignItems: 'center', width: 280, textAlign: 'center', marginTop: 10 }}>
            <span style={{ fontSize: 12, color: 'grey' }}>You must have the TeleTails App downloaded on your device in order to open this link</span>
          </div>


          <div className='flex-container-row' style={{ marginTop: 25 }}>
            <a target="_blank" href='https://apps.apple.com/us/app/teletails/id1419680694'><img className="sign-in-logo-image" src={app_store_logo} style={{ width: 120 }} alt="Icon Text" /></a>
            <div style={{ width: 5 }}></div>
            <a target="_blank" href='https://play.google.com/store/apps/details?id=com.teletails&hl=en_US'> <img className="sign-in-logo-image" src={google_play_logo} style={{ width: 120 }} alt="Icon Text" /></a>
          </div>



        </div>
      </div>
    );
  }

  renderiOSAnchor = (display) => {
    if (!display) {
      return null;
    }

    return <a style={{ padding: 10,
                backgroundColor: '#1dc2ff',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: 10,
                paddingRight: 25,
                paddingLeft: 25,
                marginTop: 15 }}
              href={this.state.ios_href}>Open in TeleTails App</a>
  }

  renderAndroidAnchor = (display) => {
    if (!display) {
      return null;
    }

    return <a style={{ padding: 10,
                backgroundColor: '#1dc2ff',
                color: 'white',
                fontWeight: 'bold',
                letterSpacing: 1,
                borderRadius: 10,
                paddingRight: 25,
                paddingLeft: 25,
                marginTop: 15 }}
              href={this.state.android_href}>Open in TeleTails App</a>
  }

}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DynamicLinkScreen)
